export default __webpack_public_path__ + "static/media/i148vp.705bd768.webp";